'use client';

import { FC, ReactNode, Suspense } from 'react';

import Navbar from '@/components/ui/navbar/HomeNavbarV2';

interface RootLayoutsProps {
  children: ReactNode;
}

const RootLayouts: FC<RootLayoutsProps> = ({ children }) => {
  return (
    <main>
      <Suspense fallback={<div />}>
        <Navbar />
      </Suspense>
      <section>{children}</section>
      {/* <ScrollToTopButton /> */}
    </main>
  );
};

export default RootLayouts;
